/**
 * Turnaround and posting deadline constants for campaign types.
 * Update these to change deadlines across the app (CreativeBrief, posting validation, etc.).
 */
import { DEFAULT_POST_TURNAROUND_DAYS } from '@foodfluence/shared';

/**
 * In-store: days after visit to submit content (display + validation).
 * Sourced from shared so this deadline and the server's clamp can't drift apart.
 */
export const IN_STORE_TURNAROUND_DAYS = DEFAULT_POST_TURNAROUND_DAYS;

/** Retail: days after acceptance to submit content */
export const RETAIL_TURNAROUND_DAYS = 14;

/** Shopify: days after order fulfillment to submit content */
export const SHOPIFY_TURNAROUND_DAYS = 14;

/** Product shipping: days for shopify/shipToHome to ship after acceptance */
export const PRODUCT_SHIPPING_DAYS = 7;
